export const tu360Inmobiliario = {
  title: 'Tu360Inmobiliario',
  pressable: false,
  brandColor: '#F5B6CD',
  categories: [
    {
      title: 'Personas',
      icon: 'user',
      actionButtonInfo: {
        title: 'Conocer más',
        url: 'https://tu360.bancolombia.com/inmobiliario/',
        hostname: 'tu360.bancolombia.com/inmobiliario/',
        delegated: 'habitat'
      },
      listOptions: [
        {
          title: 'Comprar',
          options: [
            {
              title: 'Buscar inmuebles',
              url: 'https://inmobiliariotu360.bancolombia.com/venta',
              hostname: 'inmobiliariotu360.bancolombia.com',
              delegated: '',
              isNew: false
            },
            {
              title: 'Guía para comprar vivienda',
              url: 'https://blog.bancolombia.com/educacion-financiera/guia-comprar-vivienda/?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=guia-comprar-menu',
              hostname: 'blog.bancolombia.com/educacion-financiera/guia-comprar-vivienda/',
              delegated: '',
              isNew: false
            }
          ]
        },
        {
          title: 'Vender',
          options: [
            {
              title: 'Publicar inmueble',
              url: 'https://tu360.bancolombia.com/inmobiliario/publicar-inmuebles',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: '',
              isNew: false
            },
            {
              title: 'Guía para vender',
              url: 'https://blog.bancolombia.com/educacion-financiera/guia-vender-vivienda/?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=guia-vender-menu',
              hostname: 'blog.bancolombia.com/educacion-financiera/guia-vender-vivienda',
              delegated: 'habitat',
              isNew: false
            }
          ]
        },
        {
          title: 'Financiar',
          options: [
            {
              title: 'Simulador préstamo ',
              url: 'https://www.bancolombia.com/personas/creditos/vivienda/simulador-credito-vivienda?utm_source=website&utm_medium=link&utm_campaign=always-on-tu360-inmobiliario-simular-financiacion&utm_content=megamenu-simular-financiacion',
              hostname: 'bancolombia.com/personas/creditos/vivienda/simulador-credito-vivienda/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Crédito en minutos',
              url: 'https://tu360.bancolombia.com/inmobiliario/puedo-tener-un-credito',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Beneficios especiales',
              url: 'https://tu360.bancolombia.com/inmobiliario/proyectos/financiados',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Opciones para ahorrar',
              url: 'https://www.bancolombia.com/personas/cuentas/vivienda?',
              hostname: 'https://www.bancolombia.com/personas/cuentas/vivienda',
              delegated: '',
              isNew: false
            },
            {
              title: 'Asesoría financiera',
              url: 'https://tu360.bancolombia.com/inmobiliario/asesoria-financiera/informacion-personal',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Guía para financiar',
              url: 'https://blog.bancolombia.com/educacion-financiera/guia-financiar-vivienda/?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=guia-financiar-menu',
              hostname: 'blog.bancolombia.com/educacion-financiera/guia-comprar-vivienda/o',
              delegated: '',
              isNew: false
            }
          ]
        },
        {
          title: 'Administrar y cuidar',
          options: [
            {
              title: 'Pagar administración',
              url: 'https://tu360.bancolombia.com/inmobiliario/pagos-en-linea/pagar-administracion',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Pagar arriendo',
              url: 'https://tu360.bancolombia.com/inmobiliario/pagos-en-linea/pagar-arriendo',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Pagar cuota inicial',
              url: 'https://tu360.bancolombia.com/inmobiliario/pagos-en-linea/pagar-cuota-inicial',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Sistema de alarma para hogar',
              url: 'https://tu360.bancolombia.com/inmobiliario/vivienda-segura',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: 'habitat',
              isNew: false
            },
            {
              title: 'Seguro de arrendamiento',
              url: 'https://www.bancolombia.com/personas/seguros/online/arrendamiento-seguro?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=arrendamiento-menu',
              hostname: 'https://www.bancolombia.com/personas/seguros/online/arrendamiento-seguro',
              delegated: '',
              isNew: false
            }
          ]
        }
      ]
    },
    {
      title: 'Constructoras',
      icon: 'ico-constructor',
      actionButtonInfo: {
        title: 'Conocer más',
        type: 'button',
        url: 'https://www.bancolombia.com/tu360/constructor',
        hostname: 'www.bancolombia.com/tu360/constructor#constructoras',
        delegated: '',
        isNew: false
      },
      listOptions: [
        {
          title: 'Solución para Constructoras',
          options: [
            {
              title: 'Conocer la solución',
              url: 'https://www.bancolombia.com/tu360/constructor#constructoras',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            },
            {
              title: 'Unirse a la solución',
              url: 'https://tu360.bancolombia.com/inmobiliario/constructor/landing-form',
              hostname: 'tu360.bancolombia.com/inmobiliario/constructor',
              delegated: '',
              isNew: false
            }
          ]
        },
        {
          title: 'Herramientas de Planeación',
          options: [
            {
              title: 'Análisis de zona',
              url: 'https://www.bancolombia.com/tu360/constructor/analisis-sitio',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            },
            {
              title: 'Análisis de comunidad',
              url: 'https://www.bancolombia.com/tu360/constructor/calculo-metro-cuadrado-construccion',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            }
          ]
        },
        {
          title: 'Herramientas de Comercialización',
          options: [
            {
              title: 'Venta cierta',
              url: 'https://www.bancolombia.com/tu360/constructor/venta-cierta',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            },
            {
              title: 'Módulo de comercialización',
              url: 'https://www.bancolombia.com/tu360/constructor/ofrecer-servicios-construccion',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            },
            {
              title: 'Cuota inicial',
              url: 'https://www.bancolombia.com/tu360/constructor/cuota-inicial',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: false
            },
            {
              title: 'Comprador potencial',
              url: 'https://www.bancolombia.com/tu360/constructor/perfil-comprador-potencial',
              hostname: 'www.bancolombia.com/tu360/constructor',
              delegated: '',
              isNew: true
            }
          ]
        }
      ]
    },
    {
      title: 'Agentes inmobiliarios',
      icon: 'main-users',
      actionButtonInfo: {
        title: 'Conocer más',
        url: 'https://www.bancolombia.com/tu360/agente-inmobiliario',
        hostname: 'www.bancolombia.com/tu360/',
        delegated: '',
        isNew: false
      },
      listOptions: [
        {
          title: 'Solución para Agentes Inmobiliarios',
          options: [
            {
              title: 'Conocer la solución',
              url: 'https://www.bancolombia.com/tu360/agente-inmobiliario',
              hostname: 'www.bancolombia.com/tu360/',
              delegated: '',
              isNew: false
            },
            {
              title: 'Unirse a la solución',
              url: 'https://tu360.bancolombia.com/inmobiliario/red-agentes-inmobiliarios',
              hostname: 'tu360.bancolombia.com/inmobiliario/',
              delegated: '',
              isNew: false
            },
            {
              title: 'Guía para agentes inmobiliarios',
              url: 'https://blog.bancolombia.com/educacion-financiera/guia-agentes-inmobiliarios/?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=guia-agentes-menu',
              hostname: 'blog.bancolombia.com/educacion-financiera/guia-agentes-inmobiliarios/',
              delegated: '',
              isNew: true
            }
          ]
        }
      ]
    },
    {
      title: 'Propiedad horizontal e inmobiliarias',
      icon: 'user-check-money',
      actionButtonInfo: {
        title: 'Conocer más',
        type: 'button',
        url: 'https://www.bancolombia.com/tu360/administraciones',
        hostname: 'www.bancolombia.com/tu360/administraciones',
        delegated: '',
        isNew: false
      },
      listOptions: [
        {
          title: 'Solución para Inmobiliarias y Propiedades horizontales',
          options: [
            {
              title: 'Conocer la solución',
              url: 'https://www.bancolombia.com/tu360/administraciones',
              hostname: 'www.bancolombia.com/tu360/administraciones',
              delegated: '',
              isNew: false
            },
            {
              title: 'Afiliarse a la solución',
              url: 'https://tu360.bancolombia.com/inmobiliario/administraciones/afiliacion-digital',
              hostname: 'tu360.bancolombia.com/inmobiliario/administraciones',
              delegated: '',
              isNew: false
            },
            {
              title: 'Guía para administrar propiedades',
              url: 'https://blog.bancolombia.com/educacion-financiera/guia-como-administrar-propiedades/?utm_source=website&utm_medium=link&utm_campaign=tu360inmobiliario-home&utm_content=guia-administrar-menu',
              hostname:
                'blog.bancolombia.com/educacion-financiera/guia-como-administrar-propiedades/',
              delegated: '',
              isNew: false
            }
          ]
        }
      ]
    }
  ]
};
